import {h, Fragment} from "preact"
export default function SubmitButton({ className, text }) {
    return (
        <div className={`ns-autocomplete-submit ns-d-flex ns-justify-content-center ${className}`}>
            <button type="submit" className="ns-act-btn ns-text-align-center">
                {text}
            </button>
        </div>
    )
}